import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import { connect } from 'react-redux'
import Collapse from '@material-ui/core/Collapse';
import { AssignmentTurnedIn } from '@material-ui/icons';
import { withTranslation } from 'react-i18next';
import { EmployeeDashboardMobileStyles } from '../../../styles/mobileStyles';
import { faAngleDown } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import moment from 'moment';
import ShiftCard from "./shiftCard"
import PaycodeCard from "./paycodeCard"
import { updateMobileOfferForm, updateMobileView, updateMobilePaycodeForm } from '../../actions/mobileActions'
import { updateSnackbar, updateLoading } from '../../actions'
import * as aux from "../../../auxilaries";
import {
    generateMultiSettingActionErrorMessage,
    statusIcon,
} from '../Utils/uiGenerators';
import { getSettingsOfExistingOffersBlockingNewRequest } from '../Utils/CalendarHelper';
import { ShiftSegmentTypeName, TypeOfPeriod, RequestSubtypes, RequestTypes } from '../../../Enums';
import _ from 'lodash';
import * as Net from "../Utils/dotNet";
import * as MOBILE_CONSTANTS from './constants';
import { isDatetimeInRequestPeriod, MomentFormats, isValidSettingAfterShiftStart, getValidManagerSettings } from '../../../utils';

const { PAYCODE_SIDE_PANEL, SIDE_PANEL } = MOBILE_CONSTANTS;

const getMaxProposalDate = (a, b) => {
    if (moment.utc(a.proposalDate) > moment.utc(b.proposalDate)) { return a; }
    else { return b; }
};
class DailyView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            myRequestOpen: true,
            myScheduleOpen: true,
            settingsOpen: []
        }
    }

    generateShiftCard(requestType, name, shift, onClick = () => { }, partialDates = { isPartial: false }, icon, status) {
        let segment = shift.segments?.find(x => x.segmentTypeRef.qualifier !== ShiftSegmentTypeName.BREAK_SEGMENT);
        let primaryJob = segment && segment.shortOrgJobPath ? segment.shortOrgJobPath : null;
        return <ShiftCard
            color={requestType}
            shiftType={name ? name : null}
            startDate={partialDates.isPartial ? partialDates.startDate : shift.startDateTime}
            endDate={partialDates.isPartial ? partialDates.endDate : shift.endDateTime}
            orgJob={primaryJob}
            handleOnClick={onClick}
            icon={icon}
            status={status}
            isPartial={partialDates.isPartial}
        />;
    }

    generatePanel(classes, setting, shiftCards, amountBox) {
        let { settingsOpen } = this.state;

        return <div className={classes.dailyManagerSettingPanel}>
            <div className={classes.dailyManagerSettingHeader} onClick={() => { settingsOpen[setting.id] = settingsOpen[setting.id] ? (1 - settingsOpen[setting.id]) : 1; this.setState({ settingsOpen }) }} >
                <div className={classes.dailyManagerSettingCollapse}>
                    <FontAwesomeIcon icon={faAngleDown} />
                </div>
                <div className={classes.dailyManagerSettingName}>
                    {setting.name}
                </div>
                <div className={clsx(classes.dailyManagerSettingAmountBox, amountBox)}>
                    {shiftCards.length}
                </div>
            </div>
            <Collapse
                in={settingsOpen[setting.id]}
                timeout={{ enter: 750, exit: 750 }}
                style={{ transitionDelay: "250ms" }}
            >
                {
                    shiftCards.length ?
                        <div className={classes.dailyManagerSettingShift}>
                            {shiftCards}
                        </div>
                        : null
                }
            </Collapse>
        </div>;
    }

    fetchExtraDetails = async (offerId, requestType) => {
        const { options, updateLoading, updateSnackbar } = this.props;
        var extraDetails = undefined;

        updateLoading(true);
        await Net.GetExtraDetails(options, offerId, requestType).then(async response => {
            extraDetails = response.data;
            updateLoading(false);
        }).catch(err => {
            let message = aux.handleAPIErrors(err.response)
            updateSnackbar({
                typeSnackbar: 'error',
                messageSnackbar: message,
                openSnackbar: true,
            })
            updateLoading(false);
        });

        return extraDetails;
    }

    renderMyRequestsCollapsiblePanel(index) {
        const {
            classes, t, managerSettings, myToCoverOffers,
            myToCoverRequests, mySwapOffers, myProposals, myOpenShiftRequests, myVTORequests,
            updateMobileOfferForm, updateMobileView, statusDictionary, globalConfigs,
        } = this.props;

        const { myRequestOpen } = this.state;
        const requestType = ShiftCard.colors.myRequest;
        const postedRequestDisplay = globalConfigs.postedRequestDisplay;

        let shiftCards = [];

        if (myToCoverOffers[index]) {
            for (const x of myToCoverOffers[index]) {
                let status = statusDictionary[x.status]
                let icon = statusIcon(x.status, status.color, false)
                let setting = managerSettings.find(y => y.id === x.managerSettingId);
                let partial = { isPartial: false }
                if (x.isPartial) {
                    partial = {
                        isPartial: true,
                        startDate: x.partialFromDate,
                        endDate: x.partialToDate,
                    }
                }
                shiftCards.push(this.generateShiftCard(requestType, aux.getScheduleTitle(postedRequestDisplay, x.isPartial ? x.partialShift : x.shift, setting), x.shift, async () => {

                    var extraData = await this.fetchExtraDetails(x.offerId, setting.type);

                    updateMobileOfferForm(
                        {
                            shifts: [x.shift],
                            managerSetting: setting,
                            status: x.status,
                            source: 0,
                            type: setting.type,
                            offerId: x.offerId,
                            partialDates: partial,
                            history: extraData.history,
                            raw: x,
                            isAvailableOffer: false,
                            details: setting.details,
                        }
                    )
                    updateMobileView(SIDE_PANEL);
                },
                    partial,
                    icon,
                    status.value
                ))
            }
        }

        if (myToCoverRequests[index]) {
            for (const x of myToCoverRequests[index]) {
                let status = statusDictionary[x.status]
                let icon = statusIcon(x.status, status.color, false)
                let setting = managerSettings.find(y => y.id === x.managerSettingId);
                let partial = { isPartial: false }
                if (x.isPartial) {
                    partial = {
                        isPartial: true,
                        startDate: x.partialFromDate,
                        endDate: x.partialToDate,
                    }
                }
                shiftCards.push(this.generateShiftCard(requestType, aux.getScheduleTitle(postedRequestDisplay, x.isPartial ? x.partialShift : x.shift, setting), x.shift, async () => {

                    var extraData = await this.fetchExtraDetails(x.offerId, setting.type);

                    updateMobileOfferForm(
                        {
                            shifts: [x.shift],
                            managerSetting: setting,
                            status: x.status,
                            source: 1,
                            type: setting.type,
                            offerId: x.offerId,
                            raw: x,
                            partialDates: partial,
                            history: extraData.history,
                            isAvailableOffer: false,
                            details: setting.details,
                        }
                    )
                    updateMobileView(SIDE_PANEL);
                },
                    partial,
                    icon,
                    status.value,
                ))
            }
        }

        if (mySwapOffers[index]) {
            for (const x of mySwapOffers[index]) {
                let status = statusDictionary[x.status]
                let statusFilter = [3, 4, 6, 8, 9] //same list as calendarFunctions.statusFilter
                if (x.isProposedByOfferer) {
                    statusFilter.push(0);
                }
                let icon = statusIcon(x.status, status.color, x.proposals && x.proposals.length > 0 && x.proposals.some(x => !statusFilter.includes(x.status)))
                let setting = managerSettings.find(y => y.id === x.managerSettingId);

                let partial = { isPartial: false }
                if (x.isPartial) {
                    const { startDateTime: startDate, endDateTime: endDate } = x.partialShift;
                    partial = {
                        isPartial: true,
                        startDate,
                        endDate,
                    }
                }
                for (const shift of x.shifts) {
                    shiftCards.push(this.generateShiftCard(requestType, aux.getScheduleTitle(postedRequestDisplay, x.isPartial ? x.partialShift : shift, setting), shift, async () => {

                        var extraData = await this.fetchExtraDetails(x.offerId, setting.type);

                        updateMobileOfferForm(
                            {
                                shifts: x.shifts,
                                managerSetting: setting,
                                status: x.status,
                                source: 0,
                                type: setting.type,
                                offerId: x.offerId,
                                partialDates: partial,
                                raw: x,
                                proposals: x.proposals,
                                history: extraData.history,
                                isAvailableOffer: false,
                                isProposedByOfferer: x.isProposedByOfferer,
                                details: setting.details,
                            }
                        )
                        updateMobileView(SIDE_PANEL);
                    },
                        partial,
                        icon,
                        status.value
                    ))
                }
            }
        }

        if (myProposals[index]) {
            let offersWithProposalsOnThisDay = _.uniqBy(myProposals[index], 'offerId')
            for (const uniqueOffer of offersWithProposalsOnThisDay) {
                let offersWithSameOfferId = myProposals[index].filter(x => x.offerId === uniqueOffer.offerId);
                let offerContainingProposal = offersWithSameOfferId[offersWithSameOfferId.length - 1];
                if (offerContainingProposal) {
                    let proposal = offerContainingProposal.proposals.reduce(getMaxProposalDate, offerContainingProposal.proposals[0]);
                    let status = statusDictionary[proposal.status];
                    let icon = statusIcon(proposal.status, status.color, false);
                    let setting = managerSettings.find(y => y.id === offerContainingProposal.managerSettingId);
                    let partial = { isPartial: false }
                    if (uniqueOffer.isPartial) {
                        const { startDateTime: startDate, endDateTime: endDate } = uniqueOffer.partialShift;
                        partial = {
                            isPartial: true,
                            startDate,
                            endDate,
                        }
                    }
                    for (const shift of offerContainingProposal.shifts) {
                        shiftCards.push(this.generateShiftCard(requestType, aux.getScheduleTitle(postedRequestDisplay, uniqueOffer.isPartial ? uniqueOffer.partialShift : shift, setting), shift, async () => {

                            var extraData = await this.fetchExtraDetails(offerContainingProposal.offerId, setting.type);

                            updateMobileOfferForm(
                                {
                                    shifts: offerContainingProposal.shifts,
                                    managerSetting: setting,
                                    status: offerContainingProposal.status,
                                    source: 1,
                                    type: setting.type,
                                    offerId: offerContainingProposal.offerId,
                                    raw: offerContainingProposal,
                                    proposals: offerContainingProposal.proposals,
                                    history: extraData.history,
                                    isAvailableOffer: false,
                                    isProposedByOfferer: offerContainingProposal.isProposedByOfferer,
                                    details: setting.details,
                                }
                            )
                            updateMobileView(SIDE_PANEL);
                        },
                            partial,
                            icon,
                            status.value
                        ))
                    }
                }
            }
        }

        if (myOpenShiftRequests[index]) {
            for (const x of myOpenShiftRequests[index]) {
                let status = statusDictionary[x.status]
                let icon = statusIcon(x.status, status.color, false)
                let setting = managerSettings.find(y => y.id === x.managerSettingId);
                let partial = { isPartial: false }
                if (x.isPartial) {
                    partial = {
                        isPartial: true,
                        startDate: x.partialFromDate,
                        endDate: x.partialToDate,
                    }
                }
                shiftCards.push(this.generateShiftCard(requestType, aux.getScheduleTitle(postedRequestDisplay, x.isPartial ? x.partialShift : x.shift, setting), x.shift, async () => {

                    var extraData = await this.fetchExtraDetails(x.id, 2);

                    updateMobileOfferForm(
                        {
                            shifts: [x.shift],
                            managerSetting: setting,
                            source: 0,
                            status: x.status,
                            type: 2,
                            offerId: x.id,
                            partialDates: partial,
                            raw: x,
                            history: extraData.history,
                            isAvailableOffer: false,
                            submissionPeriod: extraData.submissionPeriodDates,
                            details: setting?.details,
                        }
                    )
                    updateMobileView(SIDE_PANEL);
                },
                    partial,
                    icon,
                    status.value
                ))
            }
        }
        if (myVTORequests[index]) {
            for (const x of myVTORequests[index]) {
                let shift;
                if (x.approvedShifts.length) {
                    shift = x.approvedShifts[0].shiftInfo.shiftDetails;
                }
                else if (x.affectedShifts.length) {
                    shift = x.affectedShifts[0];
                }
                else {
                    shift = {
                        startDateTime: x.timeOffStartDate,
                        endDateTime: x.timeOffEndDate,
                    }
                }
                if (shift) {
                    let status = statusDictionary[x.status]
                    let icon = statusIcon(x.status, status.color, false)
                    let setting = managerSettings.find(y => y.id === x.managerSettingId);
                    let partial = { isPartial: false }
                    if (x.isPartial) {
                        partial = {
                            isPartial: true,
                            startDate: x.partialStartDate,
                            endDate: x.partialEndDate,
                        }
                    }
                    shiftCards.push(this.generateShiftCard(requestType, setting.name, shift, async () => {

                        var extraData = await this.fetchExtraDetails(x.offerId, 3);

                        updateMobileOfferForm(
                            {
                                shifts: [shift],
                                managerSetting: setting,
                                source: 0,
                                status: x.status,
                                type: 3,
                                offerId: x.offerId,
                                raw: x,
                                history: extraData.history,
                                isAvailableOffer: false,
                                details: x.details,
                                partialDates: partial,
                                isPartial: partial.isPartial,
                                partialStartDate: partial.startDate,
                                partialEndDate: partial.endDate,
                            }
                        )
                        updateMobileView(SIDE_PANEL);
                    },
                        partial,
                        icon,
                        status.value
                    ))
                }
            }
        }

        // TODO retracted

        return (
            <div className={classes.dailyManagerSettingPanel}>
                <div className={classes.dailyManagerSettingHeader} onClick={() => { this.setState({ myRequestOpen: 1 - this.state.myRequestOpen }) }} >
                    <div className={classes.dailyManagerSettingCollapse}>
                        <FontAwesomeIcon icon={faAngleDown} />
                    </div>
                    <div className={classes.dailyManagerSettingName}>
                        {t("dailyView.myRequests")}
                    </div>
                    <div className={clsx(classes.dailyManagerSettingAmountBox, classes.amountBoxMyRequests)}>
                        {shiftCards.length}
                    </div>
                </div>
                <Collapse
                    in={myRequestOpen}
                    timeout={{ enter: 750, exit: 750 }}
                    style={{ transitionDelay: "250ms" }}
                >
                    {
                        shiftCards.length ?
                            <div className={classes.dailyManagerSettingShift}>
                                {shiftCards}
                            </div>
                            : null
                    }

                </Collapse>
            </div>);
    }

    renderMyScheduleCollapsiblePanel(index) {
        const {
            classes,
            employeePaycodes,
            employeeShifts,
            managerSettings,
            t,
            updateMobileOfferForm,
            updateMobileView,
            updateSnackbar,
            updateMobilePaycodeForm,
            storeData,
        } = this.props;
        const { myScheduleOpen } = this.state;
        let shiftShiftCards = [];
        let paycodeShiftCards = [];

        if (employeeShifts[index]) {
            for (const x of employeeShifts[index]) {
                shiftShiftCards.push(this.generateShiftCard(ShiftCard.colors.shift, x.label && x.label !== "" ? x.label : "SHIFT", x, () => {
                    const currentTime = moment.utc().add(moment().utcOffset(), 'm').toISOString();
                    const shiftStartTime = new Date(x.startDateTime);
                    const hasShiftStarted = x.startDateTime < currentTime;
                    const hasShiftEnded = x.endDateTime < currentTime;
                    const isShiftInProgress = hasShiftStarted && !hasShiftEnded;
                    const validManagerSettingsAfterShiftStart = managerSettings.filter(x => isValidSettingAfterShiftStart(x, shiftStartTime));
                    if (hasShiftEnded || (isShiftInProgress && !validManagerSettingsAfterShiftStart.length)) {
                        updateSnackbar({
                            typeSnackbar: 'error',
                            messageSnackbar: 'Shift is in the past',
                            openSnackbar: true
                        });
                        return;
                    }

                    const newRequestBlockedResult = getSettingsOfExistingOffersBlockingNewRequest(storeData, x.id);
                    if (newRequestBlockedResult.isNewRequestBlocked) {
                        updateSnackbar({
                            typeSnackbar: 'error',
                            messageSnackbar: generateMultiSettingActionErrorMessage(newRequestBlockedResult.blockingManagerAggregateRootIds, managerSettings).message,
                            openSnackbar: true
                        });
                        return;
                    }

                    let shift = x
                    let filteredManagerSettings = managerSettings.filter(setting =>
                        setting.isVisible &&
                        (setting.toCoverPeriod_TypeOfPeriod === TypeOfPeriod.Forever
                            || moment.utc().add(moment().utcOffset(), 'm').isBetween(moment.utc(setting.toCoverPeriod_StartDate), moment.utc(setting.toCoverPeriod_EndDate), null, '[]'))
                        && isDatetimeInRequestPeriod(shift.startDateTime, setting)
                        && ![RequestTypes.openShift, RequestTypes.voluntaryTimeOff].includes(setting.type)
                    );

                    if (isShiftInProgress) {
                        const validManagerSettingsAfterShiftStartIds = validManagerSettingsAfterShiftStart.map(x => x.id);
                        filteredManagerSettings = filteredManagerSettings.filter(x => validManagerSettingsAfterShiftStartIds.includes(x.id));
                    }

                    filteredManagerSettings = getValidManagerSettings(filteredManagerSettings, [x]);
                    if (filteredManagerSettings.length === 0) {
                        updateSnackbar({
                            typeSnackbar: 'error',
                            messageSnackbar: t('billboard.noRequestsAvailable'),
                            openSnackbar: true
                        });
                        return;
                    }
                    updateMobileOfferForm(
                        {
                            shifts: [x],
                            partialDates: {
                                startDate: moment.utc(x.startDateTime),
                                endDate: moment.utc(x.endDateTime)
                            },
                            source: 0,
                            type: -1,
                        }
                    );
                    updateMobileView(SIDE_PANEL);
                }))
            }
        }

        if (employeePaycodes[index]) {
            const onClick = (selectedPaycode) => {
                updateMobileView(PAYCODE_SIDE_PANEL);
                updateMobilePaycodeForm(selectedPaycode);
            };

            for (const paycode of employeePaycodes[index]) {
                paycodeShiftCards.push(
                    <PaycodeCard
                        key={paycode.id}
                        handleOnClick={() => onClick(paycode)}
                        paycode={paycode}
                    />
                );
            }
        }

        return (
            <div className={classes.dailyManagerSettingPanel}>
                <div className={classes.dailyManagerSettingHeader} onClick={() => { this.setState({ myScheduleOpen: 1 - this.state.myScheduleOpen }) }} >
                    <div className={classes.dailyManagerSettingCollapse}>
                        <FontAwesomeIcon icon={faAngleDown} />
                    </div>
                    <div className={classes.dailyManagerSettingName}>
                        {t("dailyView.mySchedule")}
                    </div>
                    <div className={clsx(classes.dailyManagerSettingAmountBox, classes.amountBoxShifts)}>
                        {shiftShiftCards.length}
                    </div>
                    <div className={clsx(classes.dailyManagerSettingAmountBox, classes.amountBoxPaycodes)}>
                        {paycodeShiftCards.length}
                    </div>
                </div>
                <Collapse
                    in={myScheduleOpen}
                    timeout={{ enter: 750, exit: 750 }}
                    style={{ transitionDelay: "250ms" }}
                >
                    {
                        shiftShiftCards.length ?
                            <div className={classes.dailyManagerSettingShift}>
                                {shiftShiftCards}
                            </div>
                            : null
                    }
                    {
                        paycodeShiftCards.length ?
                            <div className={classes.dailyManagerSettingShift}>
                                {paycodeShiftCards}
                            </div>
                            : null
                    }
                </Collapse>
            </div>);

    }

    renderToCoverCollapsiblePanels(index) {
        const { classes, toCoverOffers, managerSettings, updateMobileOfferForm, updateMobileView, globalConfigs, } = this.props;
        const requestType = ShiftCard.colors.toCover;
        const postedRequestDisplay = globalConfigs.postedRequestDisplay;
        let panels = [];

        let toCoverSettings = managerSettings.filter(x => x.type === 0);

        for (const setting of toCoverSettings) {
            let shiftCards = [];

            if (toCoverOffers[index]) {
                for (const tc of toCoverOffers[index]) {
                    if (tc.managerSettingId === setting.id) {
                        let partial = { isPartial: false }
                        if (tc.isPartial) {
                            partial = {
                                isPartial: true,
                                startDate: tc.partialFromDate,
                                endDate: tc.partialToDate,
                            }
                        }
                        shiftCards.push(this.generateShiftCard(requestType, aux.getScheduleTitle(postedRequestDisplay, tc.isPartial ? tc.partialShift : tc.shift, setting), tc.shift, async () => {

                            var extraData = await this.fetchExtraDetails(tc.offerId, setting.type);

                            updateMobileOfferForm(
                                {
                                    shifts: [tc.shift],
                                    managerSetting: setting,
                                    source: 1,
                                    type: 0,
                                    status: tc.status,
                                    raw: tc,
                                    offerId: tc.offerId,
                                    partialDates: partial,
                                    history: extraData.history,
                                    isAvailableOffer: true,
                                    details: setting.details,
                                }
                            )
                            updateMobileView(SIDE_PANEL);
                        },
                            partial
                        ))
                    }
                }
            }

            if (shiftCards.length) {
                panels.push(
                    this.generatePanel(classes, setting, shiftCards, classes.amountBoxTC)
                );
            }
        }

        return panels;
    }

    renderShiftSwapCollapsiblePanels(index) {
        const { classes, currentDay, availableShiftOffers, managerSettings, updateMobileOfferForm, updateMobileView, globalConfigs, } = this.props;
        const requestType = ShiftCard.colors.shiftSwap;
        const postedRequestDisplay = globalConfigs.postedRequestDisplay;
        let panels = [];

        let shiftSwapSettings = managerSettings.filter(x => x.type === 1);

        for (const setting of shiftSwapSettings) {
            let shiftCards = [];
            if (availableShiftOffers[index]) {
                for (const ss of availableShiftOffers[index]) {
                    if (ss.managerSettingId === setting.id) {
                        let partial = { isPartial: false }
                        if (ss.isPartial) {
                            const { startDateTime, endDateTime } = ss.partialShift;
                            partial = {
                                isPartial: true,
                                startDate: startDateTime,
                                endDate: endDateTime,
                            }
                        }
                        for (const shift of ss.shifts) {
                            if (moment(currentDay).isSame(moment.utc(shift.startDateTime), 'day') || moment(currentDay).isSame(moment(ss.partialFromDate), 'day')) {
                                shiftCards.push(this.generateShiftCard(requestType, aux.getScheduleTitle(postedRequestDisplay, ss.isPartial ? ss.partialShift : shift, setting), shift, async () => {

                                    var extraData = await this.fetchExtraDetails(ss.offerId, setting.type);

                                    updateMobileOfferForm(
                                        {
                                            shifts: ss.shifts,
                                            managerSetting: setting,
                                            source: 1,
                                            type: 1,
                                            status: ss.status,
                                            raw: ss,
                                            offerId: ss.offerId,
                                            partialDates: partial,
                                            history: extraData.history,
                                            isAvailableOffer: true,
                                            isProposedByOfferer: ss.isProposedByOfferer,
                                            details: setting.details,
                                        }
                                    )
                                    updateMobileView(SIDE_PANEL);
                                }, partial))
                            }
                        }
                    }
                }
            }

            if (shiftCards.length) {
                panels.push(
                    this.generatePanel(classes, setting, shiftCards, classes.amountBoxSS)
                );
            }
        }

        return panels;
    }

    renderOpenShiftCollapsiblePanels(index) {
        const { classes, availableOpenShifts, managerSettings, updateMobileOfferForm, updateMobileView, globalConfigs, } = this.props;
        const requestType = ShiftCard.colors.openShift;
        const postedRequestDisplay = globalConfigs.postedRequestDisplay;
        let panels = [];

        let openShiftSettings = managerSettings.filter(x => x.type === 2);

        for (const setting of openShiftSettings) {
            let shiftCards = [];

            if (availableOpenShifts[index]) {
                for (const os of availableOpenShifts[index]) {
                    if (os.managerSettingIds.includes(setting.id)) {
                        shiftCards.push(
                            this.generateShiftCard(
                                requestType,
                                aux.getScheduleTitle(postedRequestDisplay, os.shifts[0], setting),
                                os.shifts[0],
                                () => {
                                    updateMobileOfferForm({
                                        shifts: os.shifts,
                                        managerSetting: setting,
                                        source: 1,
                                        type: 2,
                                        raw: [{ ...os, managerSettingId: setting.id }],
                                        isAvailableOffer: true,
                                        details: setting.requestSubtype === RequestSubtypes.signUp ? setting.details : null,
                                        //TODO add os.submissionPeriod here!
                                    });
                                    updateMobileView(SIDE_PANEL);
                                },
                                undefined,
                                setting.requestSubtype === RequestSubtypes.signUp && <AssignmentTurnedIn className={classes.signUpIconSize}/>
                            )
                        );
                    }
                }
            }

            if (shiftCards.length) {
                panels.push(
                    this.generatePanel(classes, setting, shiftCards, classes.amountBoxOS)
                );
            }
        }

        return panels;
    }

    renderVTOCollapsiblePanels(index) {
        const { classes, availableVTO, managerSettings, updateMobileOfferForm, updateMobileView } = this.props;
        const requestType = ShiftCard.colors.voluntaryTimeOff;
        const panels = [];

        const VTOSettings = managerSettings.filter(x => x.type === 3 && x.voluntaryTimeOffType !== 1);

        for (const setting of VTOSettings) {
            let shiftCards = [];

            if (availableVTO[index]) {
                for (const vto of availableVTO[index]) {
                    if (vto.managerSettingId === setting.id) {
                        if (vto.affectedShifts.length) {
                            shiftCards.push(
                                this.generateShiftCard(requestType,
                                    setting.name,
                                    vto.affectedShifts[0],
                                    () => {
                                        updateMobileOfferForm(
                                            {
                                                shifts: vto.affectedShifts,
                                                managerSetting: setting,
                                                source: 1,
                                                type: 3,
                                                offerId: vto.offerId,
                                                raw: vto,
                                                isAvailableOffer: true,
                                                details: vto.details,
                                                partialDates: {
                                                    isPartial: false,
                                                    startDate: moment.utc(vto.startDate),
                                                    endDate: moment.utc(vto.endDate),
                                                },
                                            }
                                        )
                                        updateMobileView(SIDE_PANEL);
                                    },
                                    false,
                                    setting.requestSubtype === RequestSubtypes.signUp && <AssignmentTurnedIn className={classes.signUpIconSize}/>
                                ))
                        }
                    }
                }
            }


            if (shiftCards.length) {
                panels.push(
                    this.generatePanel(classes, setting, shiftCards, classes.amountBoxVTO)
                );
            }
        }

        return panels;
    }

    render() {
        const dayIndex = moment(this.props.currentDay).format(MomentFormats.YYMMDD);
        return (
            <React.Fragment>
                <div className={this.props.classes.dailyManagerSettingGroupPanel}>
                    {this.renderMyRequestsCollapsiblePanel(dayIndex)}
                    {this.renderMyScheduleCollapsiblePanel(dayIndex)}
                    {this.renderToCoverCollapsiblePanels(dayIndex)}
                    {this.renderShiftSwapCollapsiblePanels(dayIndex)}
                    {this.renderOpenShiftCollapsiblePanels(dayIndex)}
                    {this.renderVTOCollapsiblePanels(dayIndex)}
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        options: state.httpOptions,
        managerSettings: state.managerSettings,
        storeData: state.data,
        statusDictionary: state.statusDictionary,
        globalConfigs: state.globalConfigs,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateMobileOfferForm: payload => dispatch(updateMobileOfferForm(payload)),
        updateMobileView: payload => dispatch(updateMobileView(payload)),
        updateSnackbar: payload => dispatch(updateSnackbar(payload)),
        updateLoading: payload => dispatch(updateLoading(payload)),
        updateMobilePaycodeForm: payload => dispatch(updateMobilePaycodeForm(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('employmentBillboard')(withStyles(EmployeeDashboardMobileStyles)(DailyView)));
